"use client"

import { MetaAdsTestForm } from "@/components/integrations/meta-ads/meta-ads-test-form"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { useTranslations } from "next-intl"


export function MetaAdsTestDialog({
  open,
  onOpenChange,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
}) {
  const tUi = useTranslations("Integrations.IntegrationsMetaAdsMetaAdsTestDialog")

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle><span key={tUi("testTheCompleteMetaAdsConnection")}>{tUi("testTheCompleteMetaAdsConnection")}</span></DialogTitle>
          <DialogDescription>
            <span key={tUi("versafyWillSendOneTestLeadThroughMeta")}>{tUi("versafyWillSendOneTestLeadThroughMeta")}</span></DialogDescription>
        </DialogHeader>
        <MetaAdsTestForm
          onCancel={() => onOpenChange(false)}
          onSuccess={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  )
}
